import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref, h } from 'vue'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import {
  createRegionSetting,
  updateRegionSetting
} from '@/api/gucangSales/regionSetting'
const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref({})
const emit = __emit
const toggle = (row?: any) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = { ...editForm.value }
    if (p.deptName) {
      p.deptName = p.deptName.split('/').pop()
    }
    try {
      if (editForm.value.id) {
        await updateRegionSetting(p)
      } else {
        await createRegionSetting(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "deptId",
                label: "区域",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(CustomerAreaCascader, {
                    appId: "cos_fbu",
                    deptInfoId: "815717",
                    value: editForm.value.deptId,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.deptId) = $event)),
                    label: editForm.value.deptName,
                    "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.deptName) = $event))
                  }, null, 8, ["value", "label"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "deptManager",
                label: "区域负责人",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_user_select, {
                    value: editForm.value.deptManager,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.deptManager) = $event)),
                    allowClear: "",
                    mode: "multiple"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "deptScope",
                label: "区域员工",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_user_select, {
                    value: editForm.value.deptScope,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.deptScope) = $event)),
                    allowClear: "",
                    mode: "multiple"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})